import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Box, Copy, Icon, Optional } from '@honda-canada/design-system-react';
import { useTranslation } from 'react-i18next';
import hondaRestApi from '../../core/apis/hondaRestApi';
import themeStyles from './SaveBuild.styles';
import useMyGarageToast from '../CreditAndSignupCtas/useMyGarageToast';
import { useSaveBuildUnsavedChanges } from '../../core/apiHooks/useSaveBuild';
import { gtmSaveBuildClick } from '../../core/gtm/gtmSaveBuild';
import { navigateTo } from '../../utils/common';
import { selectBodyTypesForGtm } from '../../core/reducers/vehicles';
import { selectCurrentVehicle } from '../../core/reducers/currentVehicle';
import { useAppDispatch, useAppSelector } from '../../core/utils';
import SaveBuildModal from './SaveBuildModal';
import useSaveBuildModal from './useSaveBuildModal';
const Container = themeStyles.apply(Box, 'Container');
const IconWrapper = themeStyles.apply(Box, 'IconWrapper');
const SaveBuildLabel = themeStyles.apply(Copy, 'SaveBuildLabel');
const SaveBuild = ({ componentName }) => {
    const { t } = useTranslation();
    const [showModal, setShowModal] = useState(false);
    const dispatch = useAppDispatch();
    const { triggerToast } = useMyGarageToast({ componentName });
    const { canUpdateBuild, isDiffOptions, hasUnsavedChanges, userHasUpdatedBuild, onUpdateBuildSuccess } = useSaveBuildUnsavedChanges();
    const { updateBuild, hasSaveBuildData, buildId, isProcessing, vehicle, ...saveBuildModalProps } = useSaveBuildModal({
        componentName,
        closeModal() {
            setShowModal(false);
        },
    });
    const iconHasSelectedState = canUpdateBuild && !isDiffOptions && userHasUpdatedBuild;
    const isUnclickable = isProcessing || iconHasSelectedState;
    const gtmBodyStyle = useAppSelector(selectBodyTypesForGtm);
    const { inventoryStatus } = useAppSelector(selectCurrentVehicle);
    const gtmPayload = {
        componentType: componentName,
        gtmBodyStyle,
        model: vehicle === null || vehicle === void 0 ? void 0 : vehicle.modelGtmName,
        trim: vehicle === null || vehicle === void 0 ? void 0 : vehicle.trimGtmName,
        availabilityFlag: inventoryStatus,
    };
    function handleCtaClick() {
        if (canUpdateBuild) {
            if (isDiffOptions || !userHasUpdatedBuild) {
                updateBuild({
                    onSuccess() {
                        triggerToast();
                        onUpdateBuildSuccess();
                        dispatch(hondaRestApi.util.invalidateTags([{ type: 'saved_build', id: buildId }]));
                    },
                });
            }
        }
        else
            setShowModal(true);
        gtmSaveBuildClick({
            ...gtmPayload,
            linkText: 'save build',
            linkUrl: '',
        });
    }
    return (_jsxs(_Fragment, { children: [_jsx(Optional, { when: hasSaveBuildData, children: _jsxs(Container, { "data-testid": "cy-save_build_cta", disabled: isProcessing, unclickable: isUnclickable, onClick: isUnclickable ? undefined : handleCtaClick, children: [_jsx(IconWrapper, { isActive: iconHasSelectedState, "data-testid": "cy-save_build_cta_icon", children: _jsx(Icon, { granularStyling: true, name: "star", fillColor: !iconHasSelectedState ? 'transparent' : null }) }), _jsx(SaveBuildLabel, { "data-testid": "cy-save_build_label", as: "span", size: "small", children: t(hasUnsavedChanges || !userHasUpdatedBuild ? 'Pages.Bap.updateBuildLabel' : 'Pages.Bap.saveBuildLabel') })] }) }), _jsx(SaveBuildModal, { showModal, isProcessing, vehicle, ...saveBuildModalProps })] }));
};
export default SaveBuild;
SaveBuild.navigateTo = navigateTo;
